<template>
  <div class="media-collection__callout">
    <el-row>
      <el-col :md="{ span: 12, offset: 6 }">
        <div class="callout__content text-align-center">
          <h2 class="h1" v-if="collection.heading">{{ collection.heading }}</h2>
          <div v-if="collection.body" v-html="collection.body"></div>
          <a class="el-button el-button--primary" v-if="collection.linkUrl && collection.linkText"
            :href="collection.linkUrl">{{ collection.linkText }}</a>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: 'MediaCollectionCallout',
  props: [
    'collection'
  ]
}
</script>

<style lang="scss" scoped></style>
